module.exports = __webpack_public_path__ + "static/media/52.c8cf4ed3.jpg";